import React from 'react';
import { Layer, LayersData, Visible, layerElementId, atlasId } from './layerTool';

export const Image: React.FC<{
  layersData: LayersData;
  visible: Visible;
}> = ({ layersData, visible }) => {
  const drawLayers = (layers: Layer[]) => {
    return [...layers].reverse().map((layer) => {
      const props: Record<string, string | number> = {
        id: layerElementId(layer.id),
        'data-layer': layer.name, // вводим поле для удобства инспектирования в браузере
      };

      const VisibilityWrapper: React.FC = ({ children }) => {
        // Мы не удаляем невидимый элемент. А также не присваиваем невидимость элементу напрямую.
        // Вместо этого оборачиваем элемент в невидимую группу.
        // Таким образом, даже если элемент невидим на холсте, то он продолжит отображаться в меню
        // слоев, т.к. картинка в меню ссылается на данный элемент.
        // Также, если в меню есть группа элементов, часть из которых скрыта, то картинка такой
        // группы не будет отображать эти скрытые части. Это поведение аналогично Gimp.
        if (!visible[layer.id]) {
          return <g visibility="hidden">{children}</g>;
        }
        return <>{children}</>;
      };

      if (layer.is_group) {
        const node = <g {...props}>{drawLayers(layer.nested_layers)}</g>;
        return <VisibilityWrapper key={layer.id}>{node}</VisibilityWrapper>;
      }

      if (layer.atlas_bbox === null) {
        // Бэк присылает null, если ширина или высота слоя равны нулю.
        // Не отображаем такой слой на холсте.
        return null;
      }

      const [x1, y1, x2, y2] = layer.atlas_bbox;

      const node = (
        <use
          href={`#${atlasId}`}
          clipPath={`path('M ${x1} ${y1} h ${x2 - x1} v ${y2 - y1} h ${x1 - x2} Z')`}
          x={layer.bbox[0] - x1}
          y={layer.bbox[1] - y1}
          {...props}
        />
      );

      // Также можно вырезать с помощью svg внутри svg:
      // <svg
      //   x={layer.bbox[0]}
      //   y={layer.bbox[1]}
      //   width={x2 - x1}
      //   height={y2 - y1}
      //   viewBox={`${x1} ${y1} ${x2 - x1} ${y2 - y1}`}
      //   {...props}
      // >
      //   <image href={atlasUrl} />
      // </svg>

      return <VisibilityWrapper key={layer.id}>{node}</VisibilityWrapper>;
    });
  };

  return (
    <svg width={layersData?.original_image.size[0]} height={layersData?.original_image.size[1]}>
      {drawLayers(layersData.layers)}
    </svg>
  );
};
